{
  "it": {
    "editor_ziggu": {
      "actions": {
        "apply": "Applica",
        "cancel": "Annulla",
        "link": "Link",
        "showLess": "Mostra meno",
        "showMore": "Mostra di più"
      },
      "labels": {
        "blue": "Blu",
        "green": "Verde",
        "link_text": "Testo del link",
        "orange": "Arancione",
        "pink": "Rosa",
        "purple": "Viola",
        "red": "Rosso",
        "remove_highlight": "Rimuovi evidenziazione",
        "yellow": "Giallo"
      },
      "placeholders": {
        "content": "Inizi a digitare..",
        "link": "Digiti o incolli un link"
      }
    }
  }
}
